import { render, staticRenderFns } from "./EmailVerificationComplete.vue?vue&type=template&id=9504af78"
import script from "./EmailVerificationComplete.vue?vue&type=script&lang=js"
export * from "./EmailVerificationComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports